const entryFormBlock = document.querySelector('.virtual-floor-plan-dialog');

if (entryFormBlock) {
  const slides = entryFormBlock.querySelectorAll('.slide');
  const slideController = entryFormBlock.querySelector('.slide-controller');
  const buttonPrevious = slideController.querySelector('.button-previous');
  const buttonNext = slideController.querySelector('.button-next');
  const buttonSubmit = slideController.querySelector('.button-submit');
  let currentSlide = 1;
  let totalSlides = slides.length;
  const progressBar = entryFormBlock.querySelector('.progress-bar');
  const currentSlideProgress = progressBar.querySelector('.currentSlide');
  const totalSlidesProgress = progressBar.querySelector('.totalSlides');

  function updateProgressBar() {
    currentSlideProgress.textContent = currentSlide;
    totalSlidesProgress.textContent = totalSlides - 2;

    if (currentSlide === totalSlides || currentSlide === totalSlides - 1) {
      progressBar.style.display = 'none';
    } else {
      progressBar.style.display = 'block';
    }
  }

  function updateSlideDisplay() {
    slides.forEach((slide, index) => {
      slide.style.display = 'none';
      if (index === currentSlide - 1) {
        slide.style.display = 'block';
      }
    });
  }

  function updateButtonVisibility() {
    if (currentSlide === 1) {
      buttonPrevious.style.display = 'none';
      buttonNext.style.display = 'block';
      buttonSubmit.style.display = 'none';
    } else if (currentSlide === totalSlides) {
      buttonPrevious.style.display = 'block';
      buttonNext.style.display = 'none';
      buttonSubmit.style.display = 'contents';
    } else {
      buttonPrevious.style.display = 'block';
      buttonNext.style.display = 'block';
      buttonSubmit.style.display = 'none';
    }
  }

  function updateSlide() {
    updateSlideDisplay();
    updateButtonVisibility();
    updateProgressBar();
  }

  buttonPrevious.addEventListener('click', (e) => {
    e.preventDefault();
    if (currentSlide > 1) {
      currentSlide--;
      updateSlide();
    }
  });

  buttonNext.addEventListener('click', (e) => {
    e.preventDefault();
    if (currentSlide < totalSlides) {
      currentSlide++;
      updateSlide();
    }
  });

  updateSlide();
}
